// extracted by mini-css-extract-plugin
export default {"page":"practice_page__IPZaF","grid":"practice_grid__kRkFO","col":"practice_col__1BWd8"};